@for (item of profileDataService.researcherHighlights; track item) {
  <div
    class="highlight-wrapper"
    @growOutAnimation
    @opacityInAnimation
    >
    <exl-citation-brief
      [title]="item.esploroRecord.title"
      [titleClickable]="true"
      [titleHeaderLevel]="3"
      [titleUrl]="item.href"
      [authors]="item.author"
      [type]="'portal.' + item.type"
      [lines]="item.lines"
      [dateLine]="item.date"
      [publisher]="item.esploroRecord.publisher"
      [dateLabel]="item.dateLabel"
      [altmetric]="!item.isReservedDOI"
      [doi]="item.doi"
      class="is-hoverable"
      >
      @if (profileAssetEnrichmentService.getAbstractDescription(item); as desc) {
        <mulo-expandable
          class="abstract"
          buttonPosition="right"
          [expandLabel]="'research.general.showMore' | translate"
          [collapseLabel]="'research.general.showLess' | translate"
          [ratio]="3"
          >
          <p [innerHTML]="desc | htmlSanitize"></p>
        </mulo-expandable>
      }
    </exl-citation-brief>
  </div>
}
